export default (props, vars) => `${vars?.loop?.item?.label}: `;
